Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "groups";
exports.labelBodyText = "groups Body";
exports.httpGetMethod = "GET";
exports.getCommunityListEndPoint = "/bx_block_blogpostsmanagement/communities";
exports.getAnnouncementChatsEndPoint = "/bx_block_blogpostsmanagement/community_chats/site_coordinator_chat_view"
exports.btnExampleTitle = "CLICK ME";
// Customizable Area End